import { AdminClientLink } from './AdminClientLink';

export default AdminClientLink;
